// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-dropzone{display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:1rem}.image-dropzone .content{order:1}.image-dropzone .image-preview{order:0}.image-dropzone .image-preview img{max-width:200px;width:100%;border-radius:50%}@media (max-width: 991.98px){.image-dropzone .image-preview{margin-right:0}.image-dropzone .content{margin-left:0}}\n", ""]);
// Exports
module.exports = exports;
